import { SubCategory } from "@robe/core-types";

export const fillMissingLocalizedCategoriesNames = (categories: SubCategory[]) =>
  process.env.NEXT_PUBLIC_FILL_EMPTY_LOCALIZED_CATEGORIES_NAMES === "true" ? categories.map(fillMissingLocalizedCategoryNames) : categories;

export const fillMissingLocalizedCategoryNames = (category: SubCategory): SubCategory =>
  process.env.NEXT_PUBLIC_FILL_EMPTY_LOCALIZED_CATEGORIES_NAMES === "true"
    ? {
      ...category,
      name:
          typeof category.name === "object" && "en" in category.name
            ? Object.fromEntries(
              Object.entries(category.name).map(([key, value]) => {
                const resolvedValue = !value || value === "" ? (category.name as { en: string }).en : value;

                return [key, resolvedValue];
              })
            )
            : category.name,
    }
    : category;
